export const advantages = [
  {
    id: "1",
    title: "24/7 Expert Support",
    description: "Our dedicated team is available around the clock to resolve any issues and ensure your business never misses a beat.",
    category: "Service",
    icon: "ri-customer-service-2-line",
    display_order: 1,
    is_active: true,
  },
  {
    id: "2",
    title: "Transparent Pricing",
    description: "No hidden fees, no surprise charges. Know exactly what you pay for with our clear and straightforward pricing structure.",
    category: "Pricing",
    icon: "ri-price-tag-3-line",
    display_order: 2,
    is_active: true,
  },
  {
    id: "3",
    title: "Premium Quality",
    description: "Every service is delivered with meticulous attention to detail and adherence to the highest industry standards.",
    category: "Quality",
    icon: "ri-medal-line",
    display_order: 3,
    is_active: true,
  },
  {
    id: "4",
    title: "Fast Turnaround",
    description: "Time is money. Our optimized processes deliver results 40% faster than industry averages without compromising quality.",
    category: "Service",
    icon: "ri-timer-flash-line",
    display_order: 4,
    is_active: true,
  },
  {
    id: "5",
    title: "Custom Solutions",
    description: "We do not believe in one-size-fits-all. Every solution is tailored to your specific business needs and goals.",
    category: "Service",
    icon: "ri-puzzle-line",
    display_order: 5,
    is_active: true,
  },
  {
    id: "6",
    title: "Data Security",
    description: "Enterprise-grade encryption and compliance with SOC 2, GDPR, and ISO 27001 standards to keep your data safe.",
    category: "Quality",
    icon: "ri-shield-check-line",
    display_order: 6,
    is_active: true,
  },
  {
    id: "7",
    title: "Scalable Plans",
    description: "Start small and grow seamlessly. Our infrastructure scales with your business at every stage of growth.",
    category: "Pricing",
    icon: "ri-bar-chart-grouped-line",
    display_order: 7,
    is_active: true,
  },
  {
    id: "8",
    title: "Satisfaction Guarantee",
    description: "Not happy? We will make it right. Our 100% satisfaction guarantee ensures you get the value you deserve.",
    category: "Service",
    icon: "ri-heart-3-line",
    display_order: 8,
    is_active: true,
  },
  {
    id: "9",
    title: "Industry Certified",
    description: "Our team holds over 50 industry certifications and stays current with the latest trends and technologies.",
    category: "Quality",
    icon: "ri-award-line",
    display_order: 9,
    is_active: true,
  },
];